import { Component, OnInit } from "@angular/core"
import { SchoolAdminDashboardService } from "../../services/school-admin-dashboard.service"
import { SchoolService } from "../../services/school.service"
import {
  ISchoolOption,
  ITotalRegistredUsers,
  IUsersPerApps,
  ITotalRegistredUsersProfile,
  ISegment,
  IDigitalUsages,
} from "../../models/schooladmin-dashobard"
import { ErrorHandlerService } from "../../services/error-handler.service"
import TitleBarNavigation from "../../models/titlebar/titlebar-navigation"
import * as lodash from "lodash"
import { format } from "date-fns"
import { GrayLogService } from "../../services/graylog/graylog.service"

@Component({
  selector: "seb-schooladmin-dashboard",
  templateUrl: "./schooladmin-dashboard.component.html",
  styleUrls: ["./schooladmin-dashboard.component.css"],
})
export class SchooladminDashboardComponent implements OnInit {
  hideButtonTitlebar: Boolean = true
  labelTitleModal: String = ""
  titleHeader: TitleBarNavigation[] = [
    {
      titleBreadcrumb: "Dashboard",
      routeNavigation: null,
    },
  ]
  schoolOptions: ISchoolOption[] = []
  selectedSchoolOption: ISchoolOption = null
  dashboardTotalRegistredUsers: ITotalRegistredUsers = {
    profiles: [],
    total: 0,
  }
  // Users per apps
  dashboardUsersPerApps: IUsersPerApps[] = null
  dashboardUsersPerAppsForFilter: IUsersPerApps[] = null
  selectedUsersPerApps: IUsersPerApps = null
  userPerAppsUpdateDate: any
  seriesUserPerApps: ISegment[] = null
  // Series
  selectedSerieRegistredUsersPerApp: ISegment = null
  selectedSerieDigitalUsage: ISegment = null
  // Digital usages
  dashboardDigitalUsagesFilter: IDigitalUsages[] = null
  dashboardDigitalUsages: IDigitalUsages[] = null
  profiles: Array<any> = []
  selectedProfile: any
  seriesDigitalUsages: ISegment[] = null
  digitalUsageUpdateDate: any
  // Loadings
  totalRegistredUsersLoading = true
  usersPerAppsLoading = true
  digitalUsagesLoading = true
  errorHandler: (err: any) => void

  constructor(
    private schoolAdminDashboardServices: SchoolAdminDashboardService,
    private schoolService: SchoolService,
    private errorHandlerService: ErrorHandlerService,
    private grayLogService: GrayLogService
  ) {
    this.errorHandler = this.errorHandlerService.handle(
      "status",
      "dashboard_school_admin_error",
      "status"
    )
  }

  ngOnInit() {
    this.getSchoolOptions()
  }

  calculePercentage = (itemValue: number, total: number) => {
    if (itemValue && total) {
      return Number((itemValue * 100) / total).toFixed(2) + "%"
    }
    return "0%"
  }

  onChangeSelectSchoolOptions(school: any) {
    this.getUsers(school.id)
    this.getCachedUserPerApps(school.id)
    this.getCachedSegmentsAndProfiles(school.id)
  }

  onSelectProfile(profile: any) {
    this.getCachedDigitalUsages(
      this.selectedSchoolOption.id,
      this.selectedSerieDigitalUsage.segmentdId,
      profile.profileId
    )
  }

  onChangeSelectSeriesDigitalUsage(segmentSelected: ISegment) {
    this.selectedSerieDigitalUsage = segmentSelected

    const newProfiles = [{ profileId: null, profileName: "Todos os perfis" }]
    newProfiles.push(...segmentSelected.profiles)
    this.profiles = newProfiles

    this.selectedProfile = this.profiles[0]

    this.getCachedDigitalUsages(
      this.selectedSchoolOption.id,
      segmentSelected.segmentdId,
      this.selectedProfile.profileId
    )
  }

  getCachedSegmentsAndProfiles(schoolId: string) {
    this.schoolAdminDashboardServices
      .getCachedSegmentsAndProfiles(schoolId)
      .subscribe(
        (data: any) => {
          const dataSegments = (data || []).sort((a, b) => {
            const aName = a.segmentName
            const bName = b.segmentName
            return aName > bName ? 1 : aName < bName ? -1 : 0
          })

          this.seriesDigitalUsages = dataSegments

          if (dataSegments.length > 0) {
            this.selectedSerieDigitalUsage = dataSegments[0]

            const newProfiles = [
              { profileId: null, profileName: "Todos os perfis" },
            ]
            newProfiles.push(...dataSegments[0].profiles)
            this.profiles = newProfiles

            this.selectedProfile = this.profiles[0]

            this.getCachedDigitalUsages(
              schoolId,
              this.selectedSerieDigitalUsage.segmentdId,
              this.selectedProfile.profileId
            )
          }

          this.digitalUsagesLoading = false
        },
        (err) => {
          if (err.status === 404) {
            this.seriesDigitalUsages = null
            this.selectedSerieDigitalUsage = null
            this.profiles = null
            this.selectedProfile = null
            this.dashboardDigitalUsages = null
            this.digitalUsagesLoading = false
          } else {
            this.errorHandler(err)
          }
        }
      )
  }

  getCachedDigitalUsages(
    schoolId: string,
    segmentId: string,
    profileId?: string
  ) {
    this.schoolAdminDashboardServices
      .getCachedDigitalUsages(schoolId, segmentId, profileId)
      .subscribe((data: any) => {
        this.digitalUsageUpdateDate = this.formatDate(data.createDate)
        this.dashboardDigitalUsages = data.products.map((p) => {
          return {
            ...p,
            percentage: `${p.percent}%`,
          }
        })
        this.dashboardDigitalUsages = lodash.orderBy(
          this.dashboardDigitalUsages,
          "percent",
          "desc"
        )
      })
  }

  onChangeSelectSeriesInUsersPerApp(segmentSelected: ISegment) {
    this.dashboardUsersPerApps = segmentSelected.products

    this.selectedUsersPerApps = segmentSelected.products[0]
    this.selectedUsersPerApps.profiles = lodash.orderBy(
      segmentSelected.products[0].profiles.map((p) => ({
        ...p,
        percentage: this.calculePercentage(
          p.total,
          segmentSelected.products[0].total
        ),
      })),
      "total",
      "desc"
    )
  }

  onChangeSelectProductInUsersPerApp(appSelected: IUsersPerApps) {
    this.selectedUsersPerApps.profiles = lodash.orderBy(
      appSelected.profiles.map((p) => ({
        ...p,
        percentage: this.calculePercentage(p.total, appSelected.total),
      })),
      "total",
      "desc"
    )
  }

  getSchoolOptions() {
    this.schoolService.getSchoolOptions().subscribe(
      (data: ISchoolOption[]) => {
        if (typeof data !== "undefined" && data && data.length > 0) {
          this.schoolOptions = data
          this.selectedSchoolOption = data[0]
          this.getUsers(data[0].id)
          this.getCachedUserPerApps(data[0].id)
          this.getCachedSegmentsAndProfiles(data[0].id)
        }
      },
      (err) => {
        let full_message = "getSchoolOptions/ERROR" + err.message
        this.grayLogService.logError(full_message)

        this.errorHandler(err)
      }
    )
  }

  getUsers(schoolIds: string) {
    if (typeof schoolIds === "undefined" || !schoolIds) {
      this.dashboardTotalRegistredUsers = null
      return false
    }
    this.totalRegistredUsersLoading = true
    this.schoolAdminDashboardServices.getUsers(schoolIds).subscribe(
      (data: ITotalRegistredUsers) => {
        const changeColor = (index: number) => {
          if (index === 0) return "#4FA5B0"
          if (index === 1) return "#5AB0AE"
          if (index === 2) return "#51BEAE"

          return "#51BEAE"
        }
        if (data) {
          data.profiles = lodash.orderBy(
            data.profiles.map(
              (item: ITotalRegistredUsersProfile, index: number) => ({
                ...item,
                percentage: this.calculePercentage(item.total, data.total),
                color: changeColor(index),
              })
            ),
            ["total"],
            ["desc"]
          )
        }

        this.dashboardTotalRegistredUsers = data
      },
      (err) => {
        this.totalRegistredUsersLoading = false
        let full_message = "getUsers/ERROR: " + err.message
        this.grayLogService.logError(full_message)

        this.errorHandler(err)
      },
      () => (this.totalRegistredUsersLoading = false)
    )
  }

  getCachedUserPerApps(schoolId: string) {
    this.schoolAdminDashboardServices
      .getCachedUsersPerApplications(schoolId)
      .subscribe(
        (data: any) => {
          this.userPerAppsUpdateDate = this.formatDate(data.createDate)

          const dataSegments = (data.segments || []).sort((a, b) => {
            const aName = a.segmentName
            const bName = b.segmentName
            return aName > bName ? 1 : aName < bName ? -1 : 0
          })

          this.seriesUserPerApps = dataSegments

          if (dataSegments.length > 0) {
            this.selectedSerieRegistredUsersPerApp = dataSegments[0].segmentName

            this.selectedUsersPerApps = dataSegments[0].products[0]

            this.selectedUsersPerApps.profiles = lodash.orderBy(
              dataSegments[0].products[0].profiles.map((p) => ({
                ...p,
                percentage: this.calculePercentage(
                  p.total,
                  dataSegments[0].products[0].total
                ),
              })),
              "total",
              "desc"
            )

            this.dashboardUsersPerApps = dataSegments[0].products
          }

          this.usersPerAppsLoading = false
        },
        (err) => {
          if (err.status === 404) {
            this.userPerAppsUpdateDate = null
            this.seriesUserPerApps = null
            this.selectedSerieRegistredUsersPerApp = null
            this.selectedUsersPerApps = null
            this.dashboardUsersPerApps = null
            this.usersPerAppsLoading = false
          } else {
            this.errorHandler(err)
          }
        }
      )
  }

  formatDate(date: string) {
    return format(new Date(date), "dd/MM/yyyy  HH:mm")
  }
}
